
import { Product, Service, Course } from '../types';

export const products: Product[] = [
  {
    id: '1',
    name: 'Panel Solar 400W',
    price: 850,
    description: 'Panel solar monocristalino de alta eficiencia',
    image: '/images/02-productos/paneles-solares/panel-solar-400w.jpg',
    category: 'antenas',
    featured: true
  },
  {
    id: '2',
    name: 'Batería Litio 100Ah',
    price: 1200,
    description: 'Batería de litio para sistemas solares',
    image: '/images/02-productos/baterias/bateria-litio.jpg',
    category: 'baterias',
    featured: true
  },
  {
    id: '3',
    name: 'Inversor 3000W',
    price: 750,
    description: 'Inversor de corriente para sistemas renovables',
    image: '/images/02-productos/inversores/inversor-3000w.webp',
    category: 'inversores',
    featured: true
  }
];
